'use client'

import { Suspense, useMemo } from 'react'
import { useSearchParams } from 'next/navigation'
import { LoginForm } from '@/components/auth/LoginForm'
import { AuthLayout } from '@/components/auth/AuthLayout'
import Link from 'next/link'
import { useI18n } from '@/components/I18nProvider'

export default function LoginPage() {
  const { t } = useI18n()

  return (
    <AuthLayout
      title={t({ es: 'Inicia sesion en BPAL', en: 'Sign in to BPAL' })}
      subtitle={t({ es: 'Accede a tu cuenta segura y continua donde lo dejaste.', en: 'Access your secure account and continue where you left off.' })}
      topActionHref="/register"
      topActionLabel={t({ es: 'Crear cuenta', en: 'Create account' })}
      footer={
        <>
          <div className="space-y-3 text-sm text-muted">
            <p>
              {t({ es: 'Olvidaste tu contrasena?', en: 'Forgot your password?' })}{' '}
              <Link href="/forgot-password" className="font-medium text-[#0f766e] hover:underline">
                {t({ es: 'Recuperar aqui', en: 'Recover here' })}
              </Link>
            </p>
            <p>
              {t({ es: 'No tienes cuenta?', en: 'No account yet?' })}{' '}
              <Link href="/register" className="font-medium text-[#0f766e] hover:underline">
                {t({ es: 'Registrarse', en: 'Sign up' })}
              </Link>
            </p>
          </div>
        </>
      }
    >
      <Suspense fallback={null}>
        <SessionExpiredBanner />
      </Suspense>
      <LoginForm />
    </AuthLayout>
  )
}

function SessionExpiredBanner() {
  const searchParams = useSearchParams()
  const { t } = useI18n()
  const sessionExpired = useMemo(
    () => searchParams.get('reason') === 'expired',
    [searchParams]
  )

  if (!sessionExpired) return null

  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
      {t({
        es: 'Sesion cerrada por tiempo. Inicia sesion de nuevo.',
        en: 'Session expired. Please sign in again.',
      })}
    </div>
  )
}
